module.exports = __webpack_public_path__ + "static/7-57dd71377edc9f86063eb3573e4c2c5a.jpg";